import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MetricAction, MetricActionType, MetricModule, MetricType, Metrics } from '../models/metrics';
import {
  PurchaseRequest,
  PurchaseRequestApproveRequestData,
  PurchaseRequestCancelRequestData,
  PurchaseRequestDeliveryDetail,
  PurchaseRequestDeliveryDetailCriteria,
  PurchaseRequestPagination,
  PurchaseRequestPreviewDiscountResponseModel,
  PurchaseRequestRejectRequestData,
  PurchaseRequestSearchCriteria
} from '../models/purchase-request.model';
import { BaseService } from './base.service';

@Injectable()
export class PurchaseRequestService extends BaseService {
  public headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.purchaseRequest;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  save(pr: PurchaseRequest): Observable<PurchaseRequest> {
    const url = this.getUrl();
    if (pr.id) {
      return this.http.put<PurchaseRequest>(url, pr, {
        headers: this.loaderHeaders(3000),
        observe: 'body'
      });
    } else {
      return this.http.post<PurchaseRequest>(url, pr, {
        headers: this.loaderHeaders(3000),
        observe: 'body'
      });
    }
  }

  public getPrByPrNo(id: string): Observable<PurchaseRequest> {
    const url = this.getFullUrl(this.envService.get, {
      id
    });

    return this.http.get<any>(url, {
      headers: this.headers,
      observe: 'body'
    });
  }

  public searchByCriteria(criteria: PurchaseRequestSearchCriteria): Observable<PurchaseRequestPagination> {
    const metricsReq: Metrics = {
      metrics: [
        {
          metricType: MetricType.RESPONSE_TIME,
          module: MetricModule.PR,
          route: this.envService.url,
          action: MetricActionType.SEARCH
        }
      ]
    };
    const params = this.getParams(criteria, true);
    return this.http.get<PurchaseRequestPagination>(this.getUrl(), {
      headers: this.loaderHeaders(null, metricsReq),
      observe: 'body',
      params
    });
  }

  public getDeliveryDetailByType(
    criteria: PurchaseRequestDeliveryDetailCriteria
  ): Observable<PurchaseRequestDeliveryDetail> {
    const params = this.getParams(criteria, true);
    const url = this.getFullUrl(this.envService.deliveryDetail);
    return this.http.get<PurchaseRequestDeliveryDetail>(url, {
      headers: this.headers,
      observe: 'body',
      params
    });
  }

  public submit(pr: PurchaseRequest): Observable<PurchaseRequest> {
    const url = this.getFullUrl(this.envService.submit);

    const metricsReq: Metrics = {
      metrics: [
        {
          metricType: MetricType.COUNTER,
          module: MetricModule.PR,
          path: window.location.pathname
        },
        {
          metricType: MetricType.HISTOGRAM,
          module: MetricModule.PR,
          path: window.location.pathname,
          action: MetricAction.CREATE,
          type: pr.type,
          items: pr.items.length
        },
        {
          metricType: MetricType.RESPONSE_TIME,
          module: MetricModule.PR,
          route: this.envService.submit,
          action: MetricActionType.SUBMIT
        }
      ]
    };

    return this.http.post<PurchaseRequest>(url, pr, {
      headers: this.loaderHeaders(3000, metricsReq),
      observe: 'body'
    });
  }

  delete(id: string): Observable<PurchaseRequest> {
    const url = this.getFullUrl(this.envService.deleted, {
      id
    });
    return this.http.delete<PurchaseRequest>(url, {
      headers: this.loaderHeaders(3000),
      observe: 'body'
    });
  }

  cancel(prCancelRequest: PurchaseRequestCancelRequestData): Observable<PurchaseRequest> {
    const url = this.getFullUrl(this.envService.cancel);

    const metricsReq: Metrics = {
      metrics: [
        {
          metricType: MetricType.COUNTER,
          module: MetricModule.PR,
          path: window.location.pathname
        }
        // {
        //   metricType: MetricType.HISTOGRAM,
        //   module: 'PR',
        //   action: 'approve'
        // }
      ]
    };

    return this.http.post<PurchaseRequest>(url, prCancelRequest, {
      headers: this.loaderHeaders(3000, metricsReq),
      observe: 'body'
    });
  }

  approve(prApprove: PurchaseRequestApproveRequestData): Observable<PurchaseRequest> {
    const url = this.getFullUrl(this.envService.approve);

    const metricsReq: Metrics = {
      metrics: [
        {
          metricType: MetricType.COUNTER,
          module: MetricModule.PR,
          path: window.location.pathname
        }
        // {
        //   metricType: MetricType.HISTOGRAM,
        //   module: 'PR',
        //   action: 'approve'
        // }
      ]
    };

    return this.http.post<PurchaseRequest>(url, prApprove, {
      headers: this.loaderHeaders(3000, metricsReq),
      observe: 'body'
    });
  }

  reject(prReject: PurchaseRequestRejectRequestData): Observable<PurchaseRequest> {
    const url = this.getFullUrl(this.envService.reject);
    return this.http.post<PurchaseRequest>(url, prReject, {
      headers: this.loaderHeaders(3000),
      observe: 'body'
    });
  }

  searchFreeItems(term) {
    const params = this.getParams(term, true);
    const url = this.getFullUrl(this.envService.supplierPromotions);
    return this.http.get<any>(url, {
      headers: this.headers,
      observe: 'body',
      params
    });
  }

  getPurchaseRequestPreviewDiscount(payload): Observable<PurchaseRequestPreviewDiscountResponseModel> {
    const url = this.getFullUrl(this.envService.previewDiscount);
    return this.http.post<any>(url, payload, {
      headers: this.loaderHeaders()
    });
  }
}
